<template>
    <div class="row">
        <div class="col-lg-6">
            <span v-if="totalElements > 0"> {{totalElements}} resultado(s) encontrado(s).</span>
            <span v-else> Sin resultados.</span>
        </div>
        <div class="col-lg-6">
        <paginate
            v-if="totalElements > 0"
            :value="pageNumber"
            :page-count="totalPages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="changePage"
            :prev-text="'«'"
            :next-text="'»'"
            :pageClass="'footable-page'"
            :container-class="'pagination pull-right'">
        </paginate>
        </div>
    </div>
</template>
<style>

</style>

<script>
    export default {
        props: {
            totalElements: {
                type: Number,
                required: true
            },
            pageNumber: {
                type: Number,
                required: true
            },
            totalPages: {
                type: Number,
                required: true
            },
            changePage: {
                type: Function,
                required: true
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/common/Paginator.vue